import Axios from 'axios';

export default {

  getArtifactsJson: async params => {
    return Axios.post('Page/GetArtifactsJson', params);
  },

  getSchema: async params => {
    return Axios.post('page/schema', params);
  },

  getSchemaProcedure: params => Axios.post('page/procedureschema', params),

  executeProcedureAction: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }
    form.append('params', JSON.stringify(params));

    return Axios.post('page/procedure', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  executeProcedureActionList: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }

    form.append('params', JSON.stringify(params));

    return Axios.post('page/procedurelist', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  executeComponentAction: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }

    form.append('params', JSON.stringify(params));

    return Axios.post('page/component', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  executeComponentActionList: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }

    form.append('params', JSON.stringify(params));

    return Axios.post('page/componentlist', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  executeRequestApiAction: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }

    form.append('params', JSON.stringify(params));

    return Axios.post('page/requestApi', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  executeRequestApiActionList: (params, files) => {
    let form = new FormData();

    if (files) {
      for (let [key, value] of Object.entries(files)) {
        form.append(key, value, value.name);
      }
    }

    form.append('params', JSON.stringify(params));

    return Axios.post('page/requestApilist', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  lookups: params => Axios.post('lookup/lookup', params),

  initLookups: params => Axios.post('lookup/initlookup', params),

  initLookupsList: params => Axios.post('lookup/initlookuplist', params),

  lookupWindow: params => Axios.post('lookup/lookupwindow', params),

  graphicData: params => Axios.post('page/graphicdata', params),

  cleanCache: params => Axios.post('page/cleancache', params)

};
